<template>
    <div class="page-main">
        <dt-search-bar style="padding:20px 5px 5px;">
            <template slot="filterSlot">
                <data-filter
                    ref="dataFilterRef"
                    :schoolId="schoolId"
                    :timeData="timeData"
                    :timesolt="$route.query.timeSolt"
                    :startdate="$route.query.startDate"
                    :enddate="$route.query.endDate"
                    :filters="filters"
                    :contentObject="contentObject"
                    :buttonColor="'#00CAAF'"
                    @filter-data="filterData"
                ></data-filter>
            </template>
            <template slot="buttonSlot">
                <div style="display: flex;float: right;">
                    <!--搜索框-->
                    <div class="big-data-search-input">
                        <input placeholder="支持场景编码、行为编码关键字搜索" class="big-data-input-cla" v-model="listFilters.keyWord"
                               v-on:keyup.enter="handleSearch"/>
                        <div class="big-data-search-btn" v-on:click="handleSearch">
                            <div class="big-data-search-icon">
                                <img src="../../../../assets/images/databoard/detailPage/search.png" width="100%"
                                     height="100%"/>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </dt-search-bar>
        <div class="table-main-wrap">
            <div class="table-main">
                <Table :columns="teaDetailsColumn" :data="teaDetailsList"
                       :row-class-name="rowClassName" :loading="isLoading"></Table>
            </div>
            <div class="bottom-page">
                <div class="laypage_main">
                    <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                          v-if="pageParams.total && pageParams.pageCount>1" show-total></Page>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {findUsageRecordByProduct} from "../../../../service/bigDataApi.js";

    const DtSearchBar = () => import('../../../../components/DtSearchBar');
    const DataFilter = () => import('../../../../components/DataFilter');
    export default {
        name: "class-list",
        components: {
            DtSearchBar,
            DataFilter
        },
        watch: {
            'listFilters.keyWord': {
                handler(newValue, oldValue) {
                    this.handleSearch();
                },
                deep: true
            }
        },
        data() {
            return {
                //加载中
                isLoading: true,
                //日期集合
                timeData: [
                    {
                        key: 0,
                        value: '全部'
                    }, {
                        key: 1,
                        value: '近一周'
                    }, {
                        key: 2,
                        value: '近一月'
                    }, {
                        key: 3,
                        value: '自定义'
                    }
                ],
                teaDetailsList: [],
                schoolId: this.$route.query.schoolId,
                listFilters: {
                    keyWord: ''

                },
                userId:this.$route.query.userId,
                filters:{
                    startDate:this.$route.query.startDate,
                    endDate:this.$route.query.endDate
                },
                //动态配置搜索框中的组件是否显示
                contentObject: {
                    //是否显示时间切换按钮
                    displayTimeFilter: true,
                },
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                },
                //教师详情列表
                teaDetailsColumn: [
                    {
                        title: "用户名称",
                        key: "full_name"
                    },
                    {
                        title: "场景编码",
                        key: "module_name"
                    },
                    {
                        title: "行为编码",
                        key: "cls_name"
                    },
                    {
                        title: "次数",
                        key: "count",
                    }
                ]
            }
        },
        created() {
            let currentPathArr;
            currentPathArr = [
                {
                    title: "首页",
                    path: this.$route.query.schoolId=='75047a8a0990480f8abf3a39bc25f1ab'?'cloudschooldataboard':"schooldataboard",
                    name: this.$route.query.schoolId=='75047a8a0990480f8abf3a39bc25f1ab'?'cloudschooldataboard':"schooldataboard",
                    params: {
                        schoolId: this.$route.query.schoolId,
                    },query:{
                        tokenId:this.$store.getters.token
                    }
                },
                {
                    title: this.$route.query.schoolName,
                    path: "",
                    name: "schoolName"
                },
                {
                    title: "全部教师",
                    path: "schoolTeacherList",
                    name: "schoolTeacherList",
                    params: {
                        schoolId: this.$route.query.schoolId,
                        schoolName: this.$route.query.schoolName,
                    }
                },
                {
                    title: this.$route.query.teaName,
                    path: "",
                    name: "teaName"
                },

            ];
            this.$store.commit("setCurrentPath", currentPathArr);
        },
        methods: {
            /**
             * 筛选数据
             */
            filterData(filters) {
                this.pageParams.page = 1;
                this.isLoading = true;
                this.filters = filters;
                this.getUsageRecordByProduct();
            },
            /**
             * 获取班级列表
             */
            async getUsageRecordByProduct() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    keyword: _this.listFilters.keyWord,
                    sTime: _this.filters.startDate,
                    eTime: _this.filters.endDate,
                    pageno: _this.pageParams.page,
                    pagesize: _this.pageParams.limit,
                    userId:_this.userId,
                    proKey: ''
                };
                let resultData = await findUsageRecordByProduct(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.isLoading = false;
                _this.teaDetailsList = [];
                _this.pageParams.total = 0;
                if (Object.keys(resultData).length > 0) {
                    _this.teaDetailsList = resultData.rows;
                    _this.pageParams.total = resultData.total_rows;
                    _this.pageParams.pageCount = resultData.page_count;
                }
            },
            /**
             * 翻页
             */
            handleCurrentChange(val) {
                this.isLoading = true;
                this.pageParams.page = val;
                this.getUsageRecordByProduct();
            },
            /**
             * 查询
             */
            handleSearch() {
                this.isLoading = true;
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.getUsageRecordByProduct();
            },
            /**
             * 表格斑马纹
             */
            rowClassName(row, index) {
                if (index % 2 == 0) {
                    return 'ivu-table-stripe-even';
                } else return 'ivu-table-stripe-odd';
            }
        },
        mounted() {
            // this.getUsageRecordByProduct();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/detailPage";

    .big-data-search-btn {
        background: #00CAAF !important;
        color: #fff;
        border-color: #00CAAF !important;
    }

    .table-main-wrap {
        margin-top: 10px !important;
    }
</style>
<style lang="scss">
    .table-main {
        /*偶数行*/
        .ivu-table-stripe-even td {
            background-color: #fff !important;
        }

        /*奇数行*/
        .ivu-table-stripe-odd td {
            background-color: #fafbfd !important;
        }

        .ivu-table th {
            background-color: #f3f7f6;
            height: 50px !important;
            line-height: 50px !important;
        }
        .ivu-table td, .ivu-table th {
            border-bottom: 0;
        }
        .ivu-table:before {
            background-color: #efefef !important;
        }
        .ivu-table:after {
            background-color: #efefef !important;
        }
        .ivu-table-wrapper {
            border-top: 1px solid #efefef;
            border-left: 1px solid #efefef;
        }
    }
</style>

